import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import Router from './router/Router';

import { verifyTokenAsync } from './store/actions/authorize';
import { setAuthToken } from './services/httpService';

function App() {
   const dispatch = useDispatch();
   const { expiredAt, accessToken, authLoading } = useSelector((state) => state.auth);
   const [loading, setLoading] = useState(authLoading);

   useEffect(() => {
      dispatch(verifyTokenAsync());
   }, []);

   useEffect(() => {
      let timeout;
      if (!authLoading && accessToken && expiredAt) {
         setAuthToken(accessToken);
         timeout = setTimeout(() => {
            dispatch(verifyTokenAsync(true));
         }, moment(expiredAt).diff() - 10 * 1000);
      }
      setLoading(authLoading);
      return () => clearTimeout(timeout);
   }, [expiredAt, accessToken, authLoading]);

   if (loading) {
      return;
   }
   if (document.querySelector('.loaderF').style.display !== 'none') {
      document.querySelector('.loaderF').style.display = 'none';
   }

   return <Router />;
}

export default App;
